export const baseApiUrl = 'spot/api/web3/staking';

export const walletApiUrl = 'spot/api/web3/wallet';

export const walletV1PrivateApiUrl = 'web3/wallet/v1/private';
